module.exports = __webpack_public_path__ + "static/phoenix-922c685d56bac3370c2a40361d8cef60.png";